import { disableScroll, enableScroll } from 'helpers/scroll';

import * as Styled from './Modal.styled';

import { type ModalProps } from './Modal.typed';

import { theme } from 'helpers/Theme/Theme';

const DEFAULT_TIMEOUT = 200;

const Modal = (props: ModalProps) => {
  const {
    children,
    fixedHeader,
    fixedFooter,
    top = '50%',
    left = '50%',
    padding = theme.spacing.M16,
    closeTimeoutMS = DEFAULT_TIMEOUT,
    openTimeout = DEFAULT_TIMEOUT,
    offScreenTransform = 'translateX(-50%) translateY(100%)',
    onScreenTransform = 'translateX(-50%) translateY(-50%)',
    onRequestClose,
    ...rest
  } = props;

  return (
    <>
      <Styled.GlobalOverlayStyle openTimeout={openTimeout} />
      <Styled.Modal
        onAfterOpen={disableScroll}
        onAfterClose={enableScroll}
        overlayClassName="react-modal-overlay"
        onRequestClose={onRequestClose}
        openTimeout={openTimeout}
        closeTimeoutMS={closeTimeoutMS}
        top={top}
        left={left}
        padding={padding}
        offScreenTransform={offScreenTransform}
        onScreenTransform={onScreenTransform}
        {...rest}
      >
        <Styled.ModalContent>
          {(fixedHeader || fixedFooter) && (
            <>
              {fixedHeader}
              <Styled.ScrollableBody>{children}</Styled.ScrollableBody>
              {fixedFooter}
            </>
          )}
          {!fixedHeader && !fixedFooter && children}
        </Styled.ModalContent>
      </Styled.Modal>
    </>
  );
};

export { Modal };
